export const CHROME_VERSION_WITH_BROKEN_CANVAS = 101;
